var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAddToShoppingCartIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55.97,
  height: 65.984,
  viewBox: "0 0 55.97 65.984",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.2;}.b,.c{fill:none;stroke:#000;stroke-linecap:round;stroke-width:5px;}.b{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "a",
  transform: "translate(-168.229 -317.5)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.224,
  cy: 5.213,
  rx: 5.224,
  ry: 5.213,
  transform: "translate(181.8 373.057)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.224,
  cy: 5.213,
  rx: 5.224,
  ry: 5.213,
  transform: "translate(207.173 373.057)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(170.729 333.704)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M170.729,339.319h6.123l11.4,24.312h21.7l10.853-19.886",
  transform: "translate(-170.729 -339.319)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M192.055,372.736l-5.311,10.628h33.624",
  transform: "translate(-175.383 -349.03)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(190.311 320)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M0,0V12.706H12.706",
  transform: "translate(0 13.006) rotate(-45)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M-17438-2629.65V-2641",
  transform: "translate(17446.984 2641)"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddToShoppingCartIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AddToShoppingCartIcon.d393a7dc.svg";
export { ForwardRef as ReactComponent };